import React, { useState } from "react";
import {
Box,
Card,
Typography,
Button,
TextField,
Alert,
CircularProgress
} from "@mui/material";

import { Colors } from "../utils/colors";
import { validateEmail } from "../utils/validate";
import { useNavigate } from "react-router-dom";
import { API } from "../constant/apiConstant";
import BackHeader from "../components/BackHeader";

export default function DeleteProfileOTP(){

const navigate = useNavigate()

const [email,setEmail] = useState("")
const [loading,setLoading] = useState(false)

const [alert,setAlert] = useState({
open:false,
message:"",
severity:"success"
})

const showAlert=(severity,message,time=6000)=>{

setAlert({
open:true,
severity,
message
})

setTimeout(()=>{
setAlert(prev=>({...prev,open:false}))
},time)

}




const sendDeleteOTP = async () => {

setLoading(true)

try{

const res = await fetch(`${API.BASE_URL}/api/auth/send-delete-account-otp`,{
method:"POST",
credentials:"include",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({email})
})

const data = await res.json()

if(!data.status){

showAlert("error",data.message || "Failed to send OTP")
setLoading(false)
return

}

showAlert("success","Account deletion OTP sent to your email")

setTimeout(()=>{
navigate("/account/authmenu/account/profile-kyc/verify-delete-otp",{state:{email}})
},1500)

}catch(error){

console.log(error)

showAlert("error","Unable to connect to server")

}

setLoading(false)

}


return(

<Box
sx={{
minHeight:"100vh",
p:3,
display:"flex",
justifyContent:"center",
alignItems:"center"
}}
>

<Card sx={{p:4,borderRadius:1,width:"100%",maxWidth:500}}>

<BackHeader
title="Delete Account"
fallbackRoute="/account/authmenu/account/profile-kyc"
titleSx={{color:Colors.accent,fontWeight:700}}
/>

<Typography
sx={{
color:Colors.muted,
fontSize:14
}}
>
Enter your email to receive a deletion verification OTP.
</Typography>


{alert.open && (
<Alert severity={alert.severity} sx={{mt:2}}>
{alert.message}
</Alert>
)}


<TextField
label="Email Address"
fullWidth
sx={inputStyle}
value={email}
error={!!email && !validateEmail(email)}
helperText={
email && !validateEmail(email)
? "Invalid email format"
: ""
}
onChange={(e)=>setEmail(e.target.value)}
/>


<Button
fullWidth
variant="contained"
sx={{
mt:3,
backgroundColor:"#d32f2f",
color:"#fff",
fontWeight:700,
"&:hover":{
backgroundColor:"#b71c1c"
}
}}
disabled={!validateEmail(email) || loading}
onClick={sendDeleteOTP}
>

{loading
? <CircularProgress size={24} sx={{color:"white"}}/>
: "Send OTP"
}

</Button>


<Typography
sx={{
mt:2,
textAlign:"center",
color:Colors.muted,
fontSize:14
}}
>

Changed your mind?{" "}
<span
style={{
color:Colors.accent,
cursor:"pointer",
textDecoration:"underline",
fontWeight:600
}}
onClick={()=>navigate("/account/authmenu")}
>
Go Back
</span>

</Typography>

</Card>

</Box>

)

}


const inputStyle={
mt:2,
"& .MuiOutlinedInput-root":{
"& fieldset":{borderColor:Colors.accent},
"&:hover fieldset":{borderColor:Colors.accent},
"&.Mui-focused fieldset":{borderColor:Colors.accent}
},
"& .MuiInputLabel-root":{
color:Colors.accent
},
"& .MuiInputLabel-root.Mui-focused":{
color:Colors.accent
},
input:{
color:"whitesmoke"
}
}
